import { Theme } from "common";

export const outcomesFilterStyles = {
  formControlLabel: {
    marginLeft: "5px",
  },
  formControlLabelRoot: {
    marginLeft: "0px",
    "&&": {
      "& .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1": {
        color: Theme.palette.grey[700],
      },
    },
  },
  checkBoxRoot: {
    border: Theme.palette.grey[500],
    backgroundColor: Theme.palette.common.white,
    "& .MuiSvgIcon-root": {
      fill: "gray",
      backgroundColor: Theme.palette.common.white,
      border: Theme.palette.grey[500],
    },
  },
  checkBoxWrapper: {
    marginBottom: "15px",
  },
  filterWrapper: {
    marginRight: "7px",
  },
  inputBaseRoot: {
    paddingRight: "5px",
  },
  inputBaseInput: {
    paddingLeft: "5px",
  },
  fieldTextStyle: {
    margin: "inherit",
    color: "#666666",
  },
  datePickerFormControl: {
    display: "flex",
    width: "100%",
    "&&": {
      "& .MuiFormControl-root": {
        marginTop: "5px",
        marginBottom: "5px",
      },
    },
    "& .MuiIconButton-root": {
      marginRight: 0,
    },
  },
  dateSeparator: {
    margin: "14px 5px",
  },
};
